import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'components/core/Link';
import { Container } from 'components/core/Page';
import { Text } from 'components/core/Typography';

import './MarketingFooter.scss';

export function MarketingFooter({ today, className }) {
	return (
		<footer className={classnames('marketing-footer', className)}>
			<Container>
				<Text
					color="white"
					className="marketing-footer-text"
				>
					&copy; {today.getFullYear()} SelfStorage.com All rights
					reserved.{' '}
					<Link href="/legal/consumer">
						<span>Terms of Service</span> and{' '}
						<span>Privacy Policy</span>
					</Link>
				</Text>
			</Container>
		</footer>
	);
}

MarketingFooter.propTypes = {
	today: PropTypes.instanceOf(Date),
	className: PropTypes.string, // sf_12127_ssdc_paid_landing_refresh
};

MarketingFooter.defaultProps = {
	today: new Date(),
};

export default MarketingFooter;
